import apiRes from './apiRes'
import Vue from 'vue'

export default class authSvc {
    static menu = null

    static setSessionData (data) {
        if (data.menu) {
            this.curUser = data.username
            this.expire = data.session_expire * 1000
            apiRes.setMenu(data.menu)
        }

        if (data.language) {
            Vue.prototype.$locale = data.language === 'russian' ? 'ru' : 'en'
        }
    }

    static login (username, password, instance) {
        return apiRes.post(apiRes.baseUrl, { username: username, password: password }, instance).catch(() => {
            // alert(err)
            return false
        })
    };

    static logout () {
        window.localStorage.removeItem('jwt_token')
        this.token = null
        this.refreshToken = null
        this.curUser = null
        this.expire = null
        // app.routes.goTo(app.routesConfig.login.segment);
        // this.$window.location.assign('/login');
    };

    static get token () {
        return window.localStorage['t']
    };

    static set token (val) {
        if (val && val.length) {
            window.localStorage.setItem('t', val)
        } else {
            window.localStorage.removeItem('t')
        }
    };

    static get refreshToken () {
        return window.localStorage['rt']
    };

    static set refreshToken (val) {
        if (val && val.length) {
            window.localStorage.setItem('rt', val)
        } else {
            window.localStorage.removeItem('rt')
        }
    };

    static get curUser () {
        var val = window.localStorage['u']
        if (val) {
            try {
                return JSON.parse(val)
            } catch (e) {
            }
        }

        return null
    };

    static set curUser (val) {
        if (val) {
            window.localStorage.setItem('u', JSON.stringify(val))
        } else {
            window.localStorage.removeItem('u')
        }

        if (this.onChangeUser) this.onChangeUser()
    };

    static get expire () {
        return window.localStorage['e']
    };

    static set expire (val) {
        if (val) {
            window.localStorage.setItem('e', val)
        } else {
            window.localStorage.removeItem('e')
        }
    };
}
